// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Cybermarathon_wrapper__NDqtX {
  width: 85%;
  margin: 0 auto;
  padding-bottom: 50px;
}
.Cybermarathon_wrapper__NDqtX .Cybermarathon_swiperSlide__Np4qa {
  height: auto !important;
}
.Cybermarathon_wrapper__NDqtX .Cybermarathon_banner__lHu1y {
  display: flex;
  justify-content: space-between;
}
.Cybermarathon_wrapper__NDqtX .Cybermarathon_banner__lHu1y .Cybermarathon_left__x8Ff8 {
  align-items: center;
  display: flex;
  width: 50%;
  font-size: 56px;
  font-weight: 700;
  color: #FAF9F8;
}
.Cybermarathon_wrapper__NDqtX .Cybermarathon_banner__lHu1y .Cybermarathon_right__VeyGJ {
  display: flex;
  justify-content: flex-end;
  width: 50%;
  margin-top: 30px;
  margin-bottom: 30px;
}
.Cybermarathon_wrapper__NDqtX .Cybermarathon_banner__lHu1y .Cybermarathon_right__VeyGJ img {
  width: 100%;
}
.Cybermarathon_wrapper__NDqtX .Cybermarathon_missionItem__uryEO {
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  justify-content: space-between;
  border-radius: 12px;
  gap: 15px;
  padding: 16px 12px;
  height: 100%;
}
.Cybermarathon_wrapper__NDqtX .Cybermarathon_missionItem__uryEO .Cybermarathon_missionItemInfo__9zffM .Cybermarathon_missionItemTitle__EYbAR {
  font-size: 24px;
  font-weight: 600;
  color: #FAF9F8;
}
.Cybermarathon_wrapper__NDqtX .Cybermarathon_missionItem__uryEO .Cybermarathon_missionItemInfo__9zffM .Cybermarathon_missionItemDescription__qTQ44 {
  font-size: 16px;
  font-weight: 400;
  color: #C2BDB2;
  margin-top: 16px;
}
.Cybermarathon_wrapper__NDqtX .Cybermarathon_missionItem__uryEO .Cybermarathon_missionItemImage__lgi7r {
  display: flex;
  align-items: center;
  justify-content: center;
}
.Cybermarathon_wrapper__NDqtX .Cybermarathon_mission__aBSGR {
  display: flex;
  justify-content: space-between;
  gap: 16px;
}
.Cybermarathon_wrapper__NDqtX .Cybermarathon_tabs__3hFXK {
  display: flex;
  gap: 16px;
  margin-top: 32px;
  margin-bottom: 32px;
}
.Cybermarathon_wrapper__NDqtX .Cybermarathon_tabs__3hFXK .Cybermarathon_tab__Y-lns {
  background-color: rgba(255, 255, 255, 0.1019607843);
  border-radius: 100px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  padding: 10px 12px;
}
.Cybermarathon_wrapper__NDqtX .Cybermarathon_tabs__3hFXK .Cybermarathon_tab__Y-lns.Cybermarathon_active__3tjYO {
  background-color: #FFFFFF;
  color: #292621;
}

@media (max-width: 1100px) {
  .Cybermarathon_wrapper__NDqtX {
    padding-top: 80px;
  }
  .Cybermarathon_wrapper__NDqtX .Cybermarathon_banner__lHu1y {
    display: block;
  }
  .Cybermarathon_wrapper__NDqtX .Cybermarathon_banner__lHu1y .Cybermarathon_left__x8Ff8 {
    display: block;
    width: 100%;
    text-align: center;
  }
  .Cybermarathon_wrapper__NDqtX .Cybermarathon_banner__lHu1y .Cybermarathon_right__VeyGJ {
    display: block;
    width: unset;
    text-align: center;
  }
  .Cybermarathon_wrapper__NDqtX .Cybermarathon_missionItem__uryEO {
    width: 100%;
  }
  .Cybermarathon_wrapper__NDqtX .Cybermarathon_missionItem__uryEO .Cybermarathon_missionItemInfo__9zffM .Cybermarathon_missionItemTitle__EYbAR {
    font-size: 16px;
  }
  .Cybermarathon_wrapper__NDqtX .Cybermarathon_missionItem__uryEO .Cybermarathon_missionItemInfo__9zffM .Cybermarathon_missionItemDescription__qTQ44 {
    font-size: 14px;
  }
  .Cybermarathon_wrapper__NDqtX .Cybermarathon_missionItem__uryEO .Cybermarathon_missionItemImage__lgi7r img {
    width: 78px;
  }
}
@media (max-width: 600px) {
  .Cybermarathon_wrapper__NDqtX .Cybermarathon_banner__lHu1y .Cybermarathon_left__x8Ff8 {
    font-size: 32px;
  }
  .Cybermarathon_wrapper__NDqtX .Cybermarathon_tabs__3hFXK .Cybermarathon_tab__Y-lns {
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Cybermarathon/Cybermarathon.module.scss"],"names":[],"mappings":"AAAA;EACE,UAAA;EACA,cAAA;EACA,oBAAA;AACF;AACE;EACE,uBAAA;AACJ;AAEE;EACE,aAAA;EACA,8BAAA;AAAJ;AAEI;EACE,mBAAA;EACA,aAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAAN;AAGI;EACE,aAAA;EACA,yBAAA;EACA,UAAA;EACA,gBAAA;EACA,mBAAA;AADN;AAGM;EACE,WAAA;AADR;AAME;EACE,sBAAA;EACA,4BAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EAEA,kBAAA;EACA,YAAA;AALJ;AASM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAPR;AAUM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AARR;AAYI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAVN;AAcE;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AAZJ;AAiBE;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;AAfJ;AAiBI;EACE,mDAAA;EACA,oBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AAfN;AAiBM;EACE,yBAAA;EACA,cAAA;AAfR;;AAqBA;EACE;IACE,iBAAA;EAlBF;EAoBE;IACE,cAAA;EAlBJ;EAoBI;IACE,cAAA;IACA,WAAA;IACA,kBAAA;EAlBN;EAqBI;IACE,cAAA;IACA,YAAA;IACA,kBAAA;EAnBN;EAuBE;IACE,WAAA;EArBJ;EAwBM;IACE,eAAA;EAtBR;EAyBM;IACE,eAAA;EAvBR;EA6BM;IACE,WAAA;EA3BR;AACF;AAiCA;EAKM;IACE,eAAA;EAnCN;EA4CI;IACE,eAAA;EA1CN;AACF","sourcesContent":[".wrapper {\n  width: 85%;\n  margin: 0 auto;\n  padding-bottom: 50px;\n\n  .swiperSlide {\n    height: auto !important;\n  }\n\n  .banner {\n    display: flex;\n    justify-content: space-between;\n\n    .left {\n      align-items: center;\n      display: flex;\n      width: 50%;\n      font-size: 56px;\n      font-weight: 700;\n      color: #FAF9F8;\n    }\n\n    .right {\n      display: flex;\n      justify-content: flex-end;\n      width: 50%;\n      margin-top: 30px;\n      margin-bottom: 30px;\n\n      img {\n        width: 100%;\n      }\n    }\n  }\n\n  .missionItem {\n    background-size: cover;\n    background-repeat: no-repeat;\n    display: flex;\n    justify-content: space-between;\n    border-radius: 12px;\n    gap: 15px;\n\n    padding: 16px 12px;\n    height: 100%;\n\n    .missionItemInfo {\n\n      .missionItemTitle {\n        font-size: 24px;\n        font-weight: 600;\n        color: #FAF9F8;\n      }\n\n      .missionItemDescription {\n        font-size: 16px;\n        font-weight: 400;\n        color: #C2BDB2;\n        margin-top: 16px;\n      }\n    }\n\n    .missionItemImage {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n  }\n\n  .mission {\n    display: flex;\n    justify-content: space-between;\n    gap: 16px;\n\n\n  }\n\n  .tabs {\n    display: flex;\n    gap: 16px;\n    margin-top: 32px;\n    margin-bottom: 32px;\n\n    .tab {\n      background-color: #FFFFFF1A;\n      border-radius: 100px;\n      cursor: pointer;\n      font-size: 16px;\n      font-weight: 600;\n      color: #fff;\n      padding: 10px 12px;\n\n      &.active {\n        background-color: #FFFFFF;\n        color: #292621;\n      }\n    }\n  }\n}\n\n@media (max-width: 1100px) {\n  .wrapper {\n    padding-top: 80px;\n\n    .banner {\n      display: block;\n\n      .left {\n        display: block;\n        width: 100%;\n        text-align: center;\n      }\n\n      .right {\n        display: block;\n        width: unset;\n        text-align: center;\n      }\n    }\n\n    .missionItem {\n      width: 100%;\n\n      .missionItemInfo {\n        .missionItemTitle {\n          font-size: 16px;\n        }\n\n        .missionItemDescription {\n          font-size: 14px;\n        }\n      }\n\n      .missionItemImage {\n\n        img {\n          width: 78px;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: 600px) {\n  .wrapper {\n\n    .banner {\n\n      .left {\n        font-size: 32px;\n      }\n\n      .right {}\n    }\n\n    .tabs {\n\n\n      .tab {\n        font-size: 14px;\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Cybermarathon_wrapper__NDqtX`,
	"swiperSlide": `Cybermarathon_swiperSlide__Np4qa`,
	"banner": `Cybermarathon_banner__lHu1y`,
	"left": `Cybermarathon_left__x8Ff8`,
	"right": `Cybermarathon_right__VeyGJ`,
	"missionItem": `Cybermarathon_missionItem__uryEO`,
	"missionItemInfo": `Cybermarathon_missionItemInfo__9zffM`,
	"missionItemTitle": `Cybermarathon_missionItemTitle__EYbAR`,
	"missionItemDescription": `Cybermarathon_missionItemDescription__qTQ44`,
	"missionItemImage": `Cybermarathon_missionItemImage__lgi7r`,
	"mission": `Cybermarathon_mission__aBSGR`,
	"tabs": `Cybermarathon_tabs__3hFXK`,
	"tab": `Cybermarathon_tab__Y-lns`,
	"active": `Cybermarathon_active__3tjYO`
};
export default ___CSS_LOADER_EXPORT___;
